<template>
  <div class="text-left">
    <h3 class="mt-15 mb-0">
      {{ $t("title.thesisData") }}
    </h3>
    <h5>
      {{ $t("form.thesis.doctoral_program") }}
    </h5>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="publication.thesis.doctoral_program"
          :label="$t('form.thesis.doctoral_program')"
          required
          outlined
          readonly
          :background="'doctoral_program' in thesisFieldsChanged ? getFieldsChangedColor: ''"
        ></v-text-field>
      </v-col>
    </v-row>
    <h5>
      {{ $t("label.dates") }}
    </h5>
    <v-row>
      <v-col cols="12" sm="6" class="py-0">
        <v-text-field
          outlined
          v-model="publication.thesis.start_date"
          :label="$t('form.thesis.start_date')"
          prepend-inner-icon="event"
          readonly
          :background-color="'start_date' in thesisFieldsChanged ? getFieldsChangedColor: ''"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" class="py-0">
        <v-text-field
          outlined
          v-model="publication.thesis.deposit_date"
          :label="$t('form.thesis.deposit_date')"
          prepend-inner-icon="event"
          readonly
          :background-color="'deposit_date' in thesisFieldsChanged ? getFieldsChangedColor: ''"
        ></v-text-field>
      </v-col>
    </v-row>
    <h5>
      {{ $t("form.thesis.thesisLecture") }}
    </h5>
    <v-row>
      <v-col cols="12" sm="12" md="6" class="py-0">
        <v-text-field
          v-model="publication.thesis.read_center"
          :label="$t('form.thesis.read_center')"
          required
          outlined
          readonly
          :background-color="'read_center' in thesisFieldsChanged ? getFieldsChangedColor: ''"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="py-0">
        <v-text-field
          outlined
          v-model="publication.thesis.lecture_date"
          :label="$t('form.thesis.lecture_date')"
          prepend-inner-icon="event"
          readonly
          :background-color="'lecture_date' in thesisFieldsChanged ? getFieldsChangedColor: ''"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="py-0">
        <v-text-field
          v-model="publication.thesis.grade"
          :label="$t('form.thesis.grade')"
          required
          outlined
          readonly
          :background-color="'grade' in thesisFieldsChanged ? getFieldsChangedColor: ''"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <h5>
          {{ $t("form.thesis.international_phd") }}
        </h5>
        <v-checkbox
          class="big"
          v-model="publication.thesis.international_phd"
          :label="$t('form.thesis.internationalPhdDetail')"
          readonly
          :background-color="'international_phd' in thesisFieldsChanged ? getFieldsChangedColor: ''"
        />
      </v-col>
    </v-row>
    <h5>{{ $t("form.thesis.directors") }}</h5>
    <SelectPeopleComboBox
      :items-selected="publication.thesis.directors"
      :disabled-form="true"
      :change-color="'directors' in thesisFieldsChanged"
    />
    <h5>{{ $t("form.thesis.tutor") }}</h5>
    <v-row>
      <v-col class="py-0">
        <v-select
          :items="namePersons"
          item-text="name"
          item-value="id"
          v-model="publication.thesis.tutor"
          outlined
          :label="$t('form.thesis.tutor')"
          readonly
          :background-color="'tutor' in thesisFieldsChanged ? getFieldsChangedColor: ''"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SelectPeopleComboBox from "../../reusables/SelectPeopleComboBox";
import publication_model from "../../../mixins/model_utils/publication_model";
export default {
  components:{SelectPeopleComboBox},
  mixins: [publication_model],
  name: "ReviewModifyCommunication",
  props: {
    publication: Object,
    fieldsChanged: Object
  },

  created() {
    this.getNamePersons();
  },

  computed:{
    thesisFieldsChanged(){
      if (this.fieldsChanged.thesis !== undefined){
        return this.fieldsChanged.thesis;
      }else{
        return {}
      }
    }
  },

};
</script>
